// extracted by mini-css-extract-plugin
export var circle = "_g1-1";
export var exitConfirmationModal = "_g1-5";
export var iframe = "_g1-0";
export var offline = "_g1-3";
export var online = "_g1-2";
export var workstationSelectError = "_g1-4";